import { FC } from 'react';
import { Document, Font } from '@react-pdf/renderer';
import { CapitalActionNoticeProps } from 'further-types/lp/capital-action-notice';
import PageOne from './PageOne';
import PageTwo from './PageTwo';
import PageThree from './PageThree';

Font.registerHyphenationCallback((word) => [word]);

const CapitalActionNotice: FC<CapitalActionNoticeProps> = ({
  currencyLcy,
  firmWhiteBackgroundLogoUrl,
  firmContactEmail,
  cumulativeCapitalPosition,
  commitment,
  unfundedCommitmentBalance,
  transactionBreakdown,
  ...props
}) => {
  return (
    <Document title="Capital call notice">
      <PageOne currencyLcy={currencyLcy} {...props} />
      <PageTwo
        commitment={commitment}
        unfundedCommitmentBalance={unfundedCommitmentBalance}
        transactionBreakdown={transactionBreakdown}
        currencyLcy={currencyLcy}
      />
      <PageThree
        cumulativeCapitalPositionData={cumulativeCapitalPosition}
        contactEmail={props.capitalActionNotice.mainContactEmails}
        whiteBackgroundLogoUrl={firmWhiteBackgroundLogoUrl}
        currencyLcy={currencyLcy}
      />
    </Document>
  );
};

export default CapitalActionNotice;
